import { render } from "./WhyAttendSection.vue?vue&type=template&id=68868dfa&scoped=true"
import script from "./WhyAttendSection.vue?vue&type=script&lang=js"
export * from "./WhyAttendSection.vue?vue&type=script&lang=js"

import "./WhyAttendSection.vue?vue&type=style&index=0&id=68868dfa&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68868dfa"]])

export default __exports__